var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "list-dnt" } },
    [
      _c("b-overlay", { attrs: { show: _vm.isVerifying } }, [
        !_vm.isVerifying && !_vm.isVerified && !_vm.sharedFile.dnt
          ? _c("div", [
              _c("div", { staticClass: "row mb-3" }, [
                _c("h5", { staticClass: "col-12 text-center" }, [
                  _vm._v(
                    " Por favor ingresa el código de verificación enviado a tu correo para poder visualizar el expediente "
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "col-4 m-auto" },
                  [
                    _c("vs-card", { staticClass: " mt-5" }, [
                      _c(
                        "form",
                        { attrs: { "data-vv-scope": "security" } },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Código de verificación",
                              maxlength: "10",
                              name: "securityPin",
                              danger: _vm.errors.has(
                                "security.verificationInput"
                              ),
                              "danger-text": _vm.errors.first(
                                "security.verificationInput"
                              )
                            },
                            model: {
                              value: _vm.verificationInput,
                              callback: function($$v) {
                                _vm.verificationInput = $$v
                              },
                              expression: "verificationInput"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass: "mt-4",
                                  attrs: { color: "warning" },
                                  on: { click: _vm.verifyFile }
                                },
                                [_vm._v(" Verificar ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        !_vm.isVerifying && _vm.sharedFile.dnt
          ? _c("div", [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("PdfViewport", {
                      ref: "pdfViewport",
                      attrs: {
                        "default-page": 1,
                        s3url: _vm.selectedFile.url,
                        name: "hola"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-6 bg-white mb-5" }, [
                  _c("div", { staticClass: "text-center" }, [
                    _c("img", {
                      staticClass: " cursor-pointer logo-ed",
                      attrs: { src: _vm.logo, alt: "logo" }
                    })
                  ]),
                  _c(
                    "h5",
                    { staticClass: "mt-3", staticStyle: { color: "#7a008d" } },
                    [
                      _vm._v(" Este expediente "),
                      _vm.sharedFile.dnt.claseMercadoPublico === "int"
                        ? _c("span", [_vm._v(" interno ")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sharedFile.dnt.claseMercadoPublico === "ext"
                        ? _c("span", [_vm._v(" externo ")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sharedFile.dnt.claseMercadoPublico === "numInt"
                        ? _c("span", [_vm._v(" de numeración interna ")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sharedFile.dnt.claseMercadoPublico === "numOf"
                        ? _c("span", [_vm._v(" de numeración oficial ")])
                        : _vm._e(),
                      _vm._v(
                        " ha sido creado por " +
                          _vm._s(_vm.sharedFile.dnt.solicitanteNombre) +
                          " "
                      ),
                      _c("small", [
                        _vm._v(_vm._s(_vm.sharedFile.dnt.solicitanteEmail))
                      ]),
                      _vm._v(
                        " , perteneciente a la unidad " +
                          _vm._s(_vm.sharedFile.dnt.solicitanteGrupoNombre) +
                          " "
                      )
                    ]
                  ),
                  _c("div", { staticClass: "py-2" }, [
                    _vm._v(
                      " - Te han compartido el documento " +
                        _vm._s(_vm.sharedFile.dnt.emisorCentroCostoNombre) +
                        " "
                    ),
                    _vm.sharedFile.dnt.emisorSucursalDireccion
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.sharedFile.dnt.emisorSucursalDireccion
                              ) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.sharedFile.dnt.numeroInt
                      ? _c("span", [
                          _vm._v(
                            " número " +
                              _vm._s(_vm.sharedFile.dnt.numeroInt) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.sharedFile.dnt.fechaEmision
                      ? _c("span", [
                          _vm._v(
                            " con fecha " +
                              _vm._s(_vm.sharedFile.dnt.fechaEmision) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.sharedFile.dnt.condicionDespacho &&
                    _vm.sharedFile.dnt.condicionDespacho.toString() === "0"
                      ? _c("span", { staticClass: "py-2" }, [
                          _vm._v(" de formato papel ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.sharedFile.dnt.condicionDespacho &&
                    _vm.sharedFile.dnt.condicionDespacho.toString() === "1"
                      ? _c("span", { staticClass: "py-2" }, [
                          _vm._v(" de formato electrónico ")
                        ])
                      : _vm._e()
                  ]),
                  _vm.sharedFile.dnt.compradorArea
                    ? _c("div", { staticClass: "py-2" }, [
                        _vm._v(
                          " De origen: " +
                            _vm._s(_vm.sharedFile.dnt.compradorArea) +
                            " "
                        ),
                        _vm.sharedFile.dnt.emisorContactoArea
                          ? _c("span", [
                              _vm._v(
                                " - " +
                                  _vm._s(
                                    _vm.sharedFile.dnt.emisorContactoArea
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.sharedFile.dnt.emisorContactoNombre
                    ? _c("div", { staticClass: "py-2" }, [
                        _vm._v(
                          " - Persona Remitente: " +
                            _vm._s(_vm.sharedFile.dnt.emisorContactoNombre) +
                            " "
                        ),
                        _vm.sharedFile.dnt.emisorContactoEmail
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.sharedFile.dnt.emisorContactoEmail
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e(),
                        _vm.sharedFile.dnt.emisorContactoCargo
                          ? _c("span", { staticClass: "py-2" }, [
                              _vm._v(
                                " con el cargo de " +
                                  _vm._s(
                                    _vm.sharedFile.dnt.emisorContactoCargo
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.sharedFile.dnt.transporteNotas
                    ? _c("div", { staticClass: "py-2" }, [
                        _vm._v(
                          " - Detalle: " +
                            _vm._s(_vm.sharedFile.dnt.transporteNotas) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _vm.sharedFile.dnt.transporteViaTransporteCodigoTransporte &&
                  _vm.sharedFile.dnt.transporteViaTransporteCodigoTransporte.toString() ===
                    "0"
                    ? _c("div", { staticClass: "py-2" }, [
                        _vm._v(" - No acompaña material físico ")
                      ])
                    : _vm._e(),
                  _vm.sharedFile.dnt.transporteViaTransporteCodigoTransporte &&
                  _vm.sharedFile.dnt.transporteViaTransporteCodigoTransporte.toString() ===
                    "1"
                    ? _c("div", { staticClass: "py-2" }, [
                        _vm._v(" - Acompaña material físico ")
                      ])
                    : _vm._e(),
                  _vm.sharedFile.observaciones[0]
                    ? _c("div", [
                        _vm._v(
                          " - Observaciones: " +
                            _vm._s(
                              _vm.sharedFile.observaciones[0].observacion
                            ) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _vm.sharedFile.observaciones[1]
                    ? _c("div", [
                        _vm._v(
                          " - Materia: " +
                            _vm._s(
                              _vm.sharedFile.observaciones[1].observacion
                            ) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "mt-5 mb-5" },
                    [
                      _c("h5", [_vm._v(" Destinos / Copias ")]),
                      _c(
                        "vs-table",
                        {
                          staticClass: "wrap-table-large",
                          attrs: {
                            stripe: "",
                            data: _vm.sharedFile.destinatarios || [],
                            noDataText: "No hay destinatarios"
                          }
                        },
                        [
                          _c("template", { slot: "header" }),
                          _c(
                            "template",
                            { slot: "thead" },
                            [
                              _c("vs-th", [_vm._v(" Nombre ")]),
                              _c("vs-th", [_vm._v(" Tipo ")]),
                              _c("vs-th", [_vm._v(" Alcance ")])
                            ],
                            1
                          ),
                          [
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.sharedFile.destinatarios || [],
                                function(subject, index) {
                                  return _c(
                                    "vs-tr",
                                    { key: index },
                                    [
                                      _c("vs-td", [
                                        _vm._v(
                                          " " +
                                            _vm._s(subject.destinoListaNombre) +
                                            " "
                                        ),
                                        _vm.externalSubject.includes(
                                          subject.destinoCodigo
                                        )
                                          ? _c(
                                              "small",
                                              { staticClass: "d-block" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      subject.destinoCorreo
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _c("vs-td", [
                                        _vm._v(
                                          " " +
                                            _vm._s(subject.destinoNombre) +
                                            " "
                                        )
                                      ]),
                                      _c(
                                        "vs-td",
                                        [
                                          subject.tipoDestino.toString() === "1"
                                            ? _c(
                                                "vs-chip",
                                                { attrs: { color: "primary" } },
                                                [_vm._v(" Destinatario ")]
                                              )
                                            : _vm._e(),
                                          subject.tipoDestino.toString() === "2"
                                            ? _c(
                                                "vs-chip",
                                                { attrs: { color: "#43C3B9" } },
                                                [_vm._v(" En copia ")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c("hr"),
                  _c(
                    "div",
                    { staticClass: " mt-5 mb-5" },
                    [
                      _c("h5", [_vm._v(" Referencias ")]),
                      _c(
                        "vs-table",
                        {
                          staticClass: "wrap-table",
                          attrs: {
                            stripe: "",
                            data: _vm.sharedFile.referencias || [],
                            noDataText: "No hay otros documentos relacionados"
                          }
                        },
                        [
                          _c("template", { slot: "header" }),
                          _c(
                            "template",
                            { slot: "thead" },
                            [
                              _c("vs-th", [_vm._v(" Tipo Documento ")]),
                              _c("vs-th", [_vm._v(" Número ")])
                            ],
                            1
                          ),
                          [
                            !_vm.isSiss
                              ? _c(
                                  "tbody",
                                  [
                                    _vm.sharedFile.dnt.transportePuertoCodigo
                                      ? _c(
                                          "vs-tr",
                                          [
                                            _c("vs-td", [
                                              _vm._v(" Contrato SAFI ")
                                            ]),
                                            _c("vs-td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.sharedFile.dnt
                                                      .transportePuertoCodigo
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      _vm.sharedFile.referencias || [],
                                      function(reference) {
                                        return _c(
                                          "vs-tr",
                                          { key: reference.dntReferenciaId },
                                          [
                                            _c("vs-td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.findTypeDocument(
                                                      reference.tipoDocumento
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]),
                                            _c("vs-td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(reference.folio) +
                                                  " "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.isSiss
                              ? _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.sharedFile.referencias || [],
                                    function(reference) {
                                      return _c(
                                        "vs-tr",
                                        { key: reference.dntReferenciaId },
                                        [
                                          _c("vs-td", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.findLabelDocument(
                                                    reference.tipoDocumento
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]),
                                          _c("vs-td", [
                                            _vm._v(
                                              " " +
                                                _vm._s(reference.folio) +
                                                " "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _vm._e()
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c("hr"),
                  _c(
                    "div",
                    { staticClass: " mt-5 mb-5" },
                    [
                      _c("h5", [_vm._v(" Archivos adjuntos ")]),
                      _c(
                        "vs-table",
                        {
                          staticClass: "wrap-table",
                          attrs: {
                            stripe: "",
                            data: _vm.sharedFile.adjuntos || [],
                            noDataText: "No hay archivos adjuntos"
                          }
                        },
                        [
                          _c("template", { slot: "header" }),
                          _c(
                            "template",
                            { slot: "thead" },
                            [
                              _vm.isConvention
                                ? _c("vs-th", [_vm._v(" Nombre documento ")])
                                : _vm._e(),
                              _c("vs-th", [_vm._v(" Nombre Adjunto ")]),
                              _c("vs-th", [_vm._v(" Tipo ")]),
                              _c("vs-th", [_vm._v(" Ver ")])
                            ],
                            1
                          ),
                          [
                            _c(
                              "tbody",
                              _vm._l(_vm.sharedFile.adjuntos, function(
                                attachment
                              ) {
                                return _c(
                                  "vs-tr",
                                  { key: attachment.adjuntoId },
                                  [
                                    _vm.isConvention
                                      ? _c("vs-td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                attachment.tipoDescripcion ||
                                                  "-"
                                              ) +
                                              " "
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("vs-td", [
                                      attachment.adjuntoNombre
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  attachment.adjuntoNombre
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      attachment.nombre
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(attachment.nombre) +
                                                " "
                                            )
                                          ])
                                        : _vm._e()
                                    ]),
                                    _c("vs-td", [
                                      _vm._v(
                                        " " + _vm._s(attachment.tipo) + " "
                                      )
                                    ]),
                                    _c("vs-td", [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: "Ver archivo",
                                              expression: "'Ver archivo'"
                                            }
                                          ],
                                          staticStyle: {
                                            cursor: "pointer",
                                            width: "fit-content"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getFile(attachment)
                                            }
                                          }
                                        },
                                        [
                                          _c("vs-icon", {
                                            attrs: {
                                              icon: "description",
                                              size: "small",
                                              title: attachment.nombre
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: "Descargar archivo",
                                              expression: "'Descargar archivo'"
                                            }
                                          ],
                                          staticStyle: {
                                            cursor: "pointer",
                                            width: "fit-content"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.downloadFile(
                                                attachment
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("vs-icon", {
                                            attrs: {
                                              icon: "attachment",
                                              size: "small",
                                              title: attachment.nombre
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }